import { getRequest,  postRequest, patchRequest } from "../../config/axiosConfig";

export const createPharmacySignup = async (formData) => {
  try {
    const response = await postRequest({
      url: process.env.REACT_APP_BASE_URL + "auth/pharmacy/signup",
      data: formData
    });

    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllPharmacy = async ({ limit, page }) => {
  try {
    const response = await getRequest({
      url:
        process.env.REACT_APP_BASE_URL + `management/get-all-pharmacy?limit=${limit}&page=${page}`,
    });

    if (response?.data) {
      return {
        success: true,
        data: response,
        message: "Pharmacy fetched Successfull!",
      };
    }
    return {
      success: false,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid fetched attempt for Pharmacy.",
    };
  }
};
export const getPharmacyById = async ({ id }) => {
  try {
    const response = await postRequest({
      url:
        process.env.REACT_APP_BASE_URL + "management/get-pharmacy-by-id",
        data: {id}
    });

    if (response?.data) {
      return {
        success: true,
        data: response,
        message: "Pharmacy fetched Successfull!",
      };
    }
    return {
      success: false,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid fetched attempt for pharmacy.",
    };
  }
};

export const changePharmacyStatus = async ({ id, isActive }) => {
  try {
    const response = await patchRequest({
      url: process.env.REACT_APP_BASE_URL + "management/toggle-pharmacy-status",
      data: {
        pharmacy_id: id,
        is_active: isActive
      },
    });

    if (response?.status === 200) {
      return {
        success: response?.status === 200,
        data: response,
      };
    } else {
      return {
        success: false,
        data: response,
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid change pharmacy status.",
    };
  }
};
